// Stub to get D3 either via NPM or from the global object
module.exports = window.d3;
